





















































import { Component, Vue } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app'
import avatar from '@/components/avatar/index.vue'
import { transColor } from '@/utils/common'
import { getApplication, getMineNums, getMessageUnview } from '@/apis/home'
@Component({
  name: 'Home',
  components: {
    avatar
  }
})
export default class extends Vue {
  private unReadNum = 0
  private matterNums = {
    mine: 0,
    undo: 0
  }
  private get name () {
    return this.$store.state.user.user.name || ''
  }
  private itemClick (obj: any) {
    if (obj.id) {
      this.$router.push({path: '/' + obj.id })
    }
  }
  private transColor1 (color: string) {
    return transColor(color)
  }
  private get circleUrl () {
    return this.$store.state.user.user.headPic || ''
  }
  private get appArr() {
    return AppModule.projectList
  }
  private showUserMsg () {
    this.$router.push({ path: '/userMsg' })
  }
  private goUpcoming (flag) {
    this.$router.push({ path: '/matter/' + flag })
  }
  private goMessage () {
    this.$router.push({ path: '/message' })
  }
  private async fetchData () {
    let res = await getApplication({ state: 1 })
    if (res.code === 200) {
      // this.appArr = res.data || []
      AppModule.ChangeProject(res.data || [])
    }
  }
  private async getMessageUnview () {
    const res = await getMessageUnview()
    if (res.success) {
      this.unReadNum = res.data
    }
  }
  private async getMineNums () {
    const res = await getMineNums()
    if (res.success) {
      this.matterNums = res.data
    }
  }
  private mounted () {
    this.getMessageUnview()
    this.fetchData()
    this.getMineNums()
  }
}
